import styled from "styled-components";

export const DealerApiWrapper = styled.div`
  .tabBtn {
    justify-content: center;
    gap: 6px;
    flex-wrap: wrap;
    margin-bottom: 16px;
  }
  .muted {
    color: #6c757d;
    font-size: 13px;
  }
  .mono {
    font-family: "Consolas", "Menlo", monospace;
    font-size: 12px;
    word-break: break-all;
  }
  .pill {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    font-weight: 700;
    font-size: 12px;
    text-transform: capitalize;
    white-space: nowrap;
  }
  .pill-green {
    background: #d1f2df;
    color: #0f6b3a;
  }
  .pill-yellow {
    background: #fff3cd;
    color: #664d03;
  }
  .pill-red {
    background: #f8d7da;
    color: #842029;
  }
  .pill-grey {
    background: #e9ecef;
    color: #495057;
  }
  .filters {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    margin-bottom: 8px;
  }
  .filter-select,
  .filter-input {
    padding: 6px 8px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #fff;
  }
  .filter-input {
    width: 170px;
  }
  .action-btns {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
  }
  .action-btns button {
    text-transform: none;
    font-weight: 500;
    white-space: nowrap;
  }
  .link {
    cursor: pointer;
    color: #607afc;
    text-decoration: underline;
    background: none;
    border: none;
    padding: 0;
  }
  .cards {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin: 8px 0 16px;
  }
  .card-stat {
    flex: 1 1 140px;
    background: #f4f7ff;
    border-radius: 8px;
    padding: 12px 14px;
  }
  .card-stat .value {
    font-size: 22px;
    font-weight: 700;
    color: #1f2a5a;
  }
  .card-stat.warn {
    background: #fff3cd;
  }
  .card-stat.danger {
    background: #f8d7da;
  }
  .doc-section {
    text-align: left;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    margin-bottom: 16px;
  }
  .doc-section h3 {
    font-size: 18px;
    padding: 12px 16px;
    margin: 0;
    border-bottom: 1px solid #e0e0e0;
  }
  /* Rendered Markdown of the dealer documentation (react-markdown + remark-gfm).
     Raw HTML is not rendered: react-markdown drops it unless rehype-raw is added. */
  .doc-body {
    padding: 4px 16px 16px;
    font-size: 14px;
    line-height: 1.6;
    overflow-wrap: break-word;
  }
  .doc-body > *:first-child {
    margin-top: 12px;
  }
  .doc-body > *:last-child {
    margin-bottom: 0;
  }
  .doc-body h1,
  .doc-body h2,
  .doc-body h3,
  .doc-body h4 {
    margin: 22px 0 8px;
    font-weight: 700;
    line-height: 1.3;
  }
  .doc-body h1 {
    font-size: 19px;
  }
  .doc-body h2 {
    font-size: 17px;
  }
  .doc-body h3 {
    font-size: 15px;
  }
  .doc-body h4 {
    font-size: 14px;
    color: #495057;
  }
  .doc-body p {
    margin: 0 0 12px;
  }
  .doc-body ul,
  .doc-body ol {
    margin: 0 0 12px;
    padding-left: 22px;
  }
  .doc-body li {
    margin-bottom: 4px;
  }
  .doc-body li > p {
    margin-bottom: 4px;
  }
  .doc-body a {
    color: #607afc;
  }
  .doc-body blockquote {
    margin: 0 0 12px;
    padding: 4px 14px;
    border-left: 3px solid #ced4da;
    color: #495057;
  }
  .doc-body hr {
    margin: 20px 0;
    border: 0;
    border-top: 1px solid #e9ecef;
  }
  .doc-body code {
    font-family: "Consolas", "Menlo", monospace;
    font-size: 12.5px;
    background: #f1f3f5;
    border-radius: 3px;
    padding: 1px 5px;
    word-break: break-word;
  }
  /* The endpoint examples are JSON and curl: keep them on one line and let them scroll. */
  .doc-body pre {
    margin: 0 0 14px;
    padding: 12px 14px;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    overflow-x: auto;
  }
  .doc-body pre code {
    background: none;
    padding: 0;
    white-space: pre;
    word-break: normal;
  }
  /* Field and error-code tables are wide; scroll them instead of squeezing the page. */
  .doc-body .table-scroll {
    overflow-x: auto;
    margin-bottom: 14px;
  }
  .doc-body table {
    border-collapse: collapse;
    width: 100%;
    font-size: 13px;
  }
  .doc-body th,
  .doc-body td {
    border: 1px solid #e0e0e0;
    padding: 6px 10px;
    text-align: left;
    vertical-align: top;
  }
  .doc-body th {
    background: #f4f7ff;
    font-weight: 700;
    white-space: nowrap;
  }
  .doc-body tbody tr:nth-child(even) {
    background: #fcfcfd;
  }
  .pager {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    margin: 16px 25px 0 0;
  }
`;

// MUI <Box sx={modalStyle}> — the shell OtaUpdates/UploadRelease uses.
export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 560,
  maxWidth: "92%",
  maxHeight: "88vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "8px",
  p: 4,
};

export const wideModalStyle = { ...modalStyle, width: 1100 };
